import React, { useEffect } from 'react'
import Storagebanner from './storagerbanner/Storagebanner'
import Benifitsstorage from './Storagecardlimits/Benifitsstorage'
import Working from './storagefeature/Working'
import Storageworkingcard from './Storageworkcard/Storageworkingcard'
import Whitepaperoverview from './Storageapi/Whitepaperoverview'
import Evolve from './evolvestorage/Evolve'
import Getapp from './getappstorage/Getapp'
import Choseplanstorage from './choseplanstorage/Choseplanstorage'
import Footer from '../landing/footer/Footer'
import Header from '../landing/Header/Header'

const Storagelanding = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
    <Header />
      <Storagebanner />
      <Benifitsstorage />
      <Working />
      <Storageworkingcard />
      <Whitepaperoverview />
      <Choseplanstorage />
      <Evolve />
      <Getapp />
      <Footer />
    </>
  )
}

export default Storagelanding